import { useTranslation } from "react-i18next";

import { TableHeadCell } from "@digital-services/ui";

import { SortDirection } from "@utils/sortUtil";

interface Props {
  activeSort: string;
  sortDirection: SortDirection;
  handleSort: (val: string) => void;
}

export const ApiUsersHeaderRow = (props: Readonly<Props>) => {
  const { activeSort, sortDirection, handleSort } = props;

  const { t: tApiUserTab } = useTranslation(undefined, {
    keyPrefix: "api-users"
  });

  const header1 = "name";
  const header2 = "id";
  const header3 = "createdOn";
  const header4 = "secretStatus";

  return (
    <tr className="leading-[0px]" data-testid="thead">
      <TableHeadCell
        sortActive={activeSort === header1}
        sortDirection={sortDirection}
        onSort={() => handleSort(header1)}
      >
        <div data-testid="api-user-name-column">
          {tApiUserTab("table-columns.api-user-name")}
        </div>
      </TableHeadCell>

      <TableHeadCell
        sortActive={activeSort === header2}
        sortDirection={sortDirection}
        onSort={() => handleSort(header2)}
      >
        <div data-testid="api-user-id-column">
          {tApiUserTab("table-columns.api-user-id")}
        </div>
      </TableHeadCell>

      <TableHeadCell
        sortActive={activeSort === header3}
        sortDirection={sortDirection}
        onSort={() => handleSort(header3)}
      >
        <div data-testid="created-on-column">
          {tApiUserTab("table-columns.created-on")}
        </div>
      </TableHeadCell>

      <TableHeadCell
        sortActive={activeSort === header4}
        sortDirection={sortDirection}
        onSort={() => handleSort(header4)}
      >
        <div data-testid="secret-status-column">
          {tApiUserTab("table-columns.secret-status")}
        </div>
      </TableHeadCell>
    </tr>
  );
};
